export enum PhoneValidationStatus {
    EMPTY = 'empty',
    INVALID = 'invalid',
    VALID = 'valid',
}
